var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main row"},[_c('div',{staticClass:"content-container row"},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/img/logo.svg"),"alt":"yanbaocool logo"}}),(_vm.authSuccess)?_c('span',[_vm._v("正在跳转到研究报告...")]):_c('div',{staticClass:"red"},[_vm._v("见微用户信息验证失败")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }